import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    Button,
    Switch,
    Typography,
    Grid,
    TextField,
    CircularProgress
} from '@material-ui/core';

//css
import ModalHeaderCss from './styles';
const useStyles = ModalHeaderCss();

const QtDias = (props) => {
    const classes = useStyles();
    return (
        <TextField variant={"filled"}
            id="standard-name"
            label="Prazo de atendimento (em dias)"
            type={"number"}
            className={classes.textField}
            InputLabelProps={{ shrink: true }} 
            InputProps={{
                className: classes.multilineColor,
                inputProps: { min: 0, max: 999 },
            }}
            margin="normal"
            required
            onChange={(e)=>{
                e.target.value = Math.max(0,parseFloat(e.target.value)).toString().slice(0,3)
                props.setState({prazoAtendimento:e.target.value})
            }}
            value={props.state.prazoAtendimento === 0 ? null : props.state.prazoAtendimento }
        />
    );
};

const NmCondicao = (props) => {
    const classes = useStyles();
    return (
        <TextField variant={"filled"}
            id="standard-name"
            label="Nome da condição"
            className={classes.textField}
            InputProps={{
                className: classes.multilineColor
            }}
            margin="normal"
            required
            onChange={(e)=>{props.setState({nome:e.target.value})}}
            value={props.state.nome}
        />
    );
};

const SwitchToggle = (props) => {
    return (
        <div style={{marginTop: 15}}>
            <Typography variant="body1" gutterBottom>
                Condição padrão
            </Typography>
            <Switch
                size="small"
                checked={!props.state.flagCondicaoPadrao}
                onChange={props.handlerSwitchToggle}
            />
            {!props.state.flagCondicaoPadrao?"Sim":"Não"}
        </div>
    );
};

const AutocompleteCondicaoPadrao = (props) => {
    return (
        <Autocomplete
            id="lb_id_padraoAtrelada"
            options={props.state.listaCondicoes}
            getOptionLabel={o => o.NM_COND_PAGTO}
            onChange={props.handleCondicaoPadrao}
            loadingText={"Carregando..."}
            required
            renderInput={params => (
                <TextField
                    {...params}
                    variant={"standard"}
                    label={"Selecione a condição padrão atrelada"}
                    placeholder={"Condição padrão atrelada"}
                    fullWidth
                />
            )}
        />
    );
};

const ShowCondicaoPadrao = (props) => {
    return (
        <TextField
            variant={"filled"}
            label={"Condição padrão atrelada"}
            fullWidth
            value={props.state.nameCondicaoPadraoAtrelada}
            InputLabelProps={{ shrink: true }} 
            InputProps={{ disabled: true }} 
        />
    );
};

const PercentualDesconto = (props) => {
    const classes = useStyles();
    return (
        <TextField variant={"filled"}
            id="standard-name"
            label="Percentual de desconto"
            type={"number"}
            className={classes.textField}
            required
            InputProps={{
                className: classes.multilineColor,
                inputProps: { min: 0, max: 100},
            }}
            InputLabelProps={{ shrink: true }} 
            margin="normal"
            onChange={async (e)=>{
                const value = Math.max(0,parseFloat(e.target.value)).toString().slice(0,6);
                props.setState({percentualDesconto:value});
            }}
            value={props.state.percentualDesconto === 0 ? null : parseFloat(props.state.percentualDesconto)}
        />
    );
};

export default (props) => {
    const classes = useStyles();
    return (
        <form className={classes.container} noValidate autoComplete="off">
            {props.state.oneClick && (
                <div align="center">
                    <CircularProgress />
                </div>
            )}
            {!props.state.oneClick && (
            <>
                <NmCondicao  {...props}/>

                {props.state.tipo === 'Adicionar' &&
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <SwitchToggle  {...props}/>
                        </Grid>
                        <Grid item xs={9}>
                            {props.state.flagCondicaoPadrao && 
                                <AutocompleteCondicaoPadrao  {...props}/>
                            }
                            {!props.state.flagCondicaoPadrao &&
                                <QtDias  {...props}/>
                            }
                        </Grid>
                    </Grid>
                }

                {props.state.tipo === 'Editar' && 
                (<>
                    {props.state.flagCondicaoPadrao &&
                        <ShowCondicaoPadrao {...props}/>
                    }
                    {!props.state.flagCondicaoPadrao &&
                        <QtDias  {...props}/>
                    }

                </>)}

                <br/>
                {props.state.flagCondicaoPadrao &&
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <QtDias  {...props}/>
                        </Grid>
                        <Grid item xs={6}>
                            <PercentualDesconto {...props}/>
                        </Grid>
                    </Grid>
                }
            </>)}

            <div className={classes.buttonAction} align="right">
                <Button 
                    className={classes.buttonCancelar} 
                    onClick={()=>{props.props.router.goBack()}}
                    disabled={props.state.oneClick}
                >
                    {'Cancelar'}
                </Button>
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={props.send}
                    disabled={props.state.oneClick}
                >
                    {'Salvar'}
                </Button>
            </div>

            <br/>
        </form>
        )
}